import React, { Component } from 'react';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import jwt_decode from "jwt-decode";

class Rank extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentRank: 'Bronze',
            nextRank: 'Silver',
            currentTurnover: 0,
            requiredTurnover: 10000,
            ucoin: 0,
            rankList: [],
            loginstate: false,
            loading: true,
        };
    }

    async componentDidMount() {
        const token = localStorage.getItem('auth_token');
        if (token) {
            try {
                const decoded = jwt_decode(token);
                const username = decoded.message.playerid;
                this.setState({ loginstate: true });
                await this.loadRankInfo(token, username);
            } catch (err) {
                console.error('Rank componentDidMount error:', err);
            }
        }
        this.setState({ loading: false });
    }

    loadRankInfo = async (token, username) => {
        // TODO: API endpoint /api/v1/getrank does not exist yet
        // When implemented, it should return rank data including:
        // { status: 200, currentRank: string, nextRank: string, currentTurnover: number, requiredTurnover: number, ucoin: number, rankList: [...] }
        try {
            // const res = await instance.post("/api/v1/getrank", { userid: username, System: Systems }, { headers: { Authorization: `Bearer ${token}` } });
            // if (res.data.status === 200) {
            //     this.setState({
            //         currentRank: res.data.currentRank,
            //         nextRank: res.data.nextRank,
            //         currentTurnover: res.data.currentTurnover,
            //         requiredTurnover: res.data.requiredTurnover,
            //         ucoin: res.data.ucoin,
            //     });
            // }
            console.log('TODO: /api/v1/getrank not implemented');
        } catch (err) {
            console.error('loadRankInfo error:', err);
        }
    };

    getRankColor = (rank) => {
        const colors = {
            'Bronze': '#CD7F32',
            'Silver': '#C0C0C0',
            'Gold': '#FFD700',
            'Platinum': '#E5E4E2',
            'Diamond': '#B9F2FF',
        };
        return colors[rank] || '#CD7F32';
    };

    render() {
        const { currentRank, nextRank, currentTurnover, requiredTurnover, ucoin, loading } = this.state;
        const progressPct = Math.min((currentTurnover / requiredTurnover) * 100, 100);
        const rankColor = this.getRankColor(currentRank);

        const benefits = [
            {
                icon: (
                    <svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                ),
                title: 'uCoin Rate',
                desc: 'ทุก 100,000 Turnover = 1 uCoin',
            },
            {
                icon: (
                    <svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                ),
                title: 'เช็กอินโบนัส',
                desc: 'รับ uCoin ฟรีทุกวันที่เช็กอิน',
            },
            {
                icon: (
                    <svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 12V22H4V12M22 7H2V12H22V7ZM12 22V7M12 7H7.5C6.84 7 6.2 6.74 5.73 6.27C5.26 5.79 5 5.16 5 4.5C5 3.84 5.26 3.2 5.73 2.73C6.2 2.26 6.84 2 7.5 2C11 2 12 7 12 7ZM12 7H16.5C17.16 7 17.8 6.74 18.27 6.27C18.74 5.79 19 5.16 19 4.5C19 3.84 18.74 3.2 18.27 2.73C17.8 2.26 17.16 2 16.5 2C13 2 12 7 12 7Z" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                ),
                title: 'รางวัล',
                desc: 'แลก uCoin เป็นของรางวัลสุดพิเศษ',
            },
            {
                icon: (
                    <svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.5 10C14.5 10 14.5 10 14.5 10C16.16 10 17.5 8.66 17.5 7C17.5 5.34 16.16 4 14.5 4C12.84 4 11.5 5.34 11.5 7C11.5 8.12 12.12 9.09 13.04 9.61" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round"/>
                        <path d="M9.5 10C7.84 10 6.5 8.66 6.5 7C6.5 5.34 7.84 4 9.5 4C11.16 4 12.5 5.34 12.5 7C12.5 8.66 11.16 10 9.5 10Z" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round"/>
                        <path d="M2 20C2 17.24 5.36 15 9.5 15C10.26 15 11 15.1 11.69 15.28" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round"/>
                        <path d="M22 17C22 17 17 20.5 14 22L11 19L12.5 17.5L14 19C16 17.5 18.5 15.5 20.5 14.5L22 17Z" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                ),
                title: 'U-Pass',
                desc: 'สิทธิพิเศษสำหรับสมาชิกระดับสูง',
            },
        ];

        return (
            <div>
                <h1 className="text-xl text-highlight font-medium text-center mt-6 mb-4">สมาชิก</h1>

                {/* Rank Card */}
                <div className="w-full bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/20 p-5 mb-4">
                    <div className="flex items-center gap-4 mb-4">
                        {/* Rank Badge */}
                        <div className="w-16 h-16 rounded-full flex items-center justify-center border-2 flex-shrink-0"
                            style={{ borderColor: rankColor, background: `${rankColor}22` }}>
                            <div className="text-center">
                                <div className="text-xs font-bold" style={{ color: rankColor }}>RANK</div>
                                <div className="text-lg font-black" style={{ color: rankColor }}>
                                    {currentRank.charAt(0)}
                                </div>
                            </div>
                        </div>
                        <div className="flex-1">
                            <div className="text-xs text-gray mb-1">Current Rank</div>
                            <div className="text-xl font-bold" style={{ color: rankColor }}>{currentRank}</div>
                        </div>
                    </div>

                    {/* Progress Bar */}
                    <div className="mb-1">
                        <div className="flex justify-between text-xs text-gray mb-2">
                            <span>{currentTurnover.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            <span>{requiredTurnover.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} to upgrade to {nextRank}</span>
                        </div>
                        <div className="w-full bg-input rounded-full h-2">
                            <div
                                className="h-2 rounded-full transition-all"
                                style={{ width: `${progressPct}%`, background: `linear-gradient(to right, ${rankColor}99, ${rankColor})` }}
                            ></div>
                        </div>
                    </div>
                </div>

                {/* Benefits */}
                <div className="mb-4">
                    <h2 className="text-sm font-semibold text-highlight mb-3">สิทธิพิเศษสำหรับสมาชิก</h2>
                    <div className="flex flex-col gap-2">
                        {benefits.map((b, i) => (
                            <div key={i} className="w-full bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl border border-white/20 p-3 flex items-center gap-3">
                                <div className="w-9 h-9 bg-gradient-to-b from-button-f to-button-t rounded-full flex items-center justify-center flex-shrink-0 text-white">
                                    {b.icon}
                                </div>
                                <div>
                                    <div className="text-sm font-medium">{b.title}</div>
                                    <div className="text-xs text-gray">{b.desc}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Upgrade CTAs */}
                <div className="grid grid-cols-2 gap-3 mb-4">
                    <a role="button" onClick={() => window.history.pushState(null, null, '/deposit')}
                        className="bg-gradient-to-br from-button-f to-button-t rounded-xl p-3 text-center text-sm font-medium cursor-pointer">
                        <div className="text-xs text-white/80 mb-1">ฝากตอนนี้เพื่ออัพเกรด</div>
                        <div className="font-bold">ฝากเลย! 💰</div>
                    </a>
                    <a role="button" onClick={() => window.history.pushState(null, null, '/rewards')}
                        className="bg-gradient-to-br from-card-1-f to-card-1-t rounded-xl p-3 text-center text-sm font-medium border border-white/20 cursor-pointer">
                        <div className="text-xs text-gray mb-1">เล่นเลยเพื่ออัพเกรด</div>
                        <div className="font-bold text-highlight">เล่นเลย! 🎮</div>
                    </a>
                </div>

                {/* TODO Notice */}
                <div className="p-3 bg-input rounded-xl text-xs text-gray">
                    <div className="font-semibold text-highlight mb-1">⚠️ หมายเหตุ (สำหรับนักพัฒนา)</div>
                    <div>ระบบ Rank ยังไม่มี API backend รองรับ กรุณาเพิ่ม endpoints:</div>
                    <ul className="mt-1 space-y-0.5 list-disc list-inside">
                        <li>/api/v1/getrank - ดึง rank, turnover, ucoin ของ user</li>
                        <li>/api/v1/getrankbenefits - ดึง benefits ตาม rank</li>
                    </ul>
                </div>

                {loading && (
                    <div className="text-center text-gray text-sm mt-4">กำลังโหลด...</div>
                )}
            </div>
        );
    }
}

export default Rank;
